import { render } from "./Articulo.vue?vue&type=template&id=70abfdef&bindings={\"post\":\"data\",\"getPost\":\"options\"}"
import script from "./Articulo.vue?vue&type=script&lang=js"
export * from "./Articulo.vue?vue&type=script&lang=js"

import "./Articulo.vue?vue&type=style&index=0&lang=css"
script.render = render

export default script